import { AppointmentTooltip } from "@devexpress/dx-react-scheduler-material-ui";

export const BookingTooltipHeader = (data: any) => {
  const { children, appointmentData, classes, ...restProps } = data;
  return (
    <AppointmentTooltip.Header {...restProps} appointmentData={appointmentData}>
      {children}
    </AppointmentTooltip.Header>
  );
};
